export const PLAN_GET_SUCCESS= 'PLAN_GET_SUCCESS';
export const PLAN_GET_LOADING = 'PLAN_GET_LOADING';
export const PLAN_GET_FAILURE = 'PLAN_GET_FAILURE';
export const PLAN_GET_COMPLETE = 'PLAN_GET_COMPLETE';


export const BUY_SUCCESS= 'BUY_SUCCESS';
export const BUY_LOADING = 'BUY_LOADING';
export const BUY_FAILURE = 'BUY_FAILURE';
export const BUY_COMPLETE = 'BUY_COMPLETE';